import { useLocation } from 'react-router-dom'
import {
  getRedirectAfterLoginPath,
  REDIRECT_AFTER_LOGIN_PARAM,
  redirectTo,
} from 'src/providers/auth.provider'
import { getFormattedUrl } from 'src/utils/http.util'
import { useLocale } from 'src/hooks/use-locale'

/**
 * Sends the browser to the Lifen Connect login (through the backend), keeping the page the user
 * wanted to reach (`next` query param) across the whole round trip.
 */
export const useLifenConnectLogin = () => {
  const location = useLocation()
  const { locale } = useLocale()

  return (email: string) => {
    const callbackUrl = new URL(`/${locale}/auth/lifen-connect/callback`, window.location.origin)
    const redirectPath = getRedirectAfterLoginPath(location.search)
    if (redirectPath) {
      callbackUrl.searchParams.set(REDIRECT_AFTER_LOGIN_PARAM, redirectPath)
    }
    const loginUrl = new URL(getFormattedUrl('/auth/oidc/login'), window.location.origin)
    loginUrl.searchParams.set('callbackUrl', callbackUrl.toString())
    loginUrl.searchParams.set('login_hint', email.trim().toLowerCase())
    redirectTo(loginUrl.toString())
  }
}
